export const normalizeVersionLabel = (bundleVersion?: string): string | undefined => {
  const trimmedVersion = bundleVersion?.trim();

  if (!trimmedVersion) {
    return undefined;
  }

  const versionMatch = trimmedVersion.match(/(\d+)\.(\d+)/);

  if (!versionMatch) {
    return trimmedVersion;
  }

  return `${versionMatch[1]}.${versionMatch[2]}`;
};
